import { headerHeight } from "@remo-co/ui-core/src/constants";
import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(({ spacing }) => ({
  topBarContainer: {
    height: 60,
  },
  micCamCheckContainer: {
    minHeight: `calc(100vh - ${headerHeight}px - ${spacing(2)} - ${spacing(
      6,
    )})`, // top and bottom padding
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: spacing(2),
    paddingBottom: spacing(6),
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
}));
